import { render, staticRenderFns } from "./EmailFormatChecker.vue?vue&type=template&id=408f2913&scoped=true&"
import script from "./EmailFormatChecker.vue?vue&type=script&lang=js&"
export * from "./EmailFormatChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408f2913",
  null
  
)

export default component.exports